import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/login_log.png';

const _withScopeId = n => (_pushScopeId("data-v-62ca77ee"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "header-into"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_0
}, null, -1));

const _hoisted_4 = {
  class: "operate"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "role",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.pushPatner && _ctx.pushPatner(...args))
  }, " 免费咨询热线：17601027166 ")])])]);
}